<template>
  <div>
    <DisplayContainer
      isSubcomponent
      style="background-color: transparent"
    >
      <external-user-table
        :companies="companies"
        :realm="realm"
      ></external-user-table>
    </DisplayContainer>
  </div>
</template>

<script>
import DisplayContainer from '@/components/elements/DisplayContainer.vue';
import ExternalUserTable from '@/components/externalAccount/ExternalUserTable.vue';

import { EXTERNAL_USER_REALM } from '@/main/ExternalUser.js';

export default {
  name: 'ConstructionAccountRegistration',
  components: {
    DisplayContainer,
    ExternalUserTable
  },
  props: {
    companies: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    realm: EXTERNAL_USER_REALM.GU_USER
  }),
  mounted() {},
  methods: {}
};
</script>
